import { observer } from 'mobx-react';

import type { WizardChildProps } from '../../../../components/Wizard/types';

import { AuthSection } from './AuthSection';

interface SignupSectionProps {
  onSignupSuccess?: () => void;
  onLoginNeedsVerification?: () => void;
  wizardProps?: WizardChildProps;
  initialMode?: 'signup' | 'login';
}

export const SignupSection = observer(
  ({ onSignupSuccess, onLoginNeedsVerification, wizardProps, initialMode = 'signup' }: SignupSectionProps) => {
    return (
      <AuthSection
        initialMode={initialMode}
        wizardProps={wizardProps}
        onLoginNeedsVerification={onLoginNeedsVerification}
        onSignupSuccess={onSignupSuccess}
      />
    );
  },
);
